export default __webpack_public_path__ + "static/media/react.f3e576ba.png";